import { HighConvictionReportKeys, Period } from '@api';
import { Icon } from '@design/components/icon/Icon';
import { ScenariosData } from '@terminal/react-query-hooks/scenarios/useScenarios';
import { AssessmentWidget } from '@terminal/widgets/assessment-widget/AssessmentWidget';
import { HorizonSelector } from '@terminal/widgets/scenario/components/horizon-selector/HorizonSelector';
import {
  countReportTriggers,
  getQualityReports,
} from '@terminal/widgets/scenario/utils/scenario-table-data/scenario-table-data';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ScenarioQuality.module.scss';

export interface ScenarioQualityProps {
  scenario: ScenariosData;
  bestHorizon: Period;
  horizons: string[];
  initHorizon: string;
  isFixedIncome: boolean;
}

export const ScenarioQuality = ({
  scenario,
  bestHorizon,
  horizons,
  initHorizon,
  isFixedIncome,
}: ScenarioQualityProps) => {
  const { t } = useTranslation(['scenario']);
  const [activeHorizon, setActiveHorizon] = useState(initHorizon);

  const qualityReports = getQualityReports(scenario.report, activeHorizon);
  const gaugeValue = countReportTriggers(qualityReports);
  const activeHorizonIndex = horizons.indexOf(activeHorizon);

  const setActiveHorizonIndex = (index: number) =>
    setActiveHorizon(horizons[index]);

  const checklist = qualityReports.reduce((acc, report) => {
    acc[report.kind] = report.triggered;
    return acc;
  }, {} as Record<HighConvictionReportKeys, boolean>);

  const horizonLabels = horizons.map(horizon => (
    <span className={styles.selectorWrapper} key={horizon}>
      {horizon === bestHorizon && (
        <Icon size={12} iconName="StarFill" className={styles.styledIcon} />
      )}
      {t(`scenario:filters.horizons.${horizon}`)}
    </span>
  ));

  return (
    <AssessmentWidget
      isFixedIncome={isFixedIncome}
      gaugeValue={gaugeValue}
      horizon={bestHorizon}
      checklist={checklist}
      titleElement={
        <HorizonSelector
          horizonLabels={horizonLabels}
          onClick={setActiveHorizonIndex}
          activeHorizonIndex={activeHorizonIndex}
        />
      }
    />
  );
};
